// 確認ダイアログ（this.$bvModal.msgBoxConfirm / msgBoxOk）の見た目を会員アプリにそろえる（2026-09-28 staging 指摘）。
// 呼び出し元（約40ファイル）は触らず、ここで modalClass（assets/scss/_confirm_dialog.scss）と既定値を足す。
// 呼び出し側が渡した okVariant（danger など）・cancelVariant・modalClass はそのまま残す。
// 開いたら OK ボタンにフォーカスを置き、Enter で確定・Esc で閉じる（2026-09-29 キー操作の改善）。
// 削除・破棄やお金・予約・契約に関わる確認（okVariant: 'danger' か、文言に「削除」「決済」「キャンセル」など。
// 語の一覧は utils/keyboardOperation.js の DESTRUCTIVE_WORDS）は「キャンセル」にフォーカスし、Tab → Enter で確定する。
import Vue from 'vue'
import { isDestructiveConfirm } from '~/utils/keyboardOperation'

export const CONFIRM_MODAL_CLASS = 'gyms-confirm-dialog'

export function withConfirmDialogDefaults(options = {}, message = null) {
  const opts = options || {}
  const destructive = isDestructiveConfirm({
    message,
    okTitle: opts.okTitle,
    okVariant: opts.okVariant
  })
  const modalClass = [].concat(opts.modalClass || [], CONFIRM_MODAL_CLASS)
  return {
    centered: true,
    autoFocusButton: destructive ? 'cancel' : 'ok',
    cancelVariant: 'outline-secondary',
    ...opts,
    modalClass
  }
}

// BootstrapVue の BvModal はクラスを公開していないので、インスタンスの prototype を包む
export function installConfirmDialogStyle(VueCtor) {
  const probe = new VueCtor()
  const bv = probe.$bvModal
  probe.$destroy()
  if (!bv) return false
  const proto = Object.getPrototypeOf(bv)
  if (proto.__gymsConfirmDialogStyled) return true
  const { msgBoxConfirm, msgBoxOk } = proto
  proto.msgBoxConfirm = function (message, options) {
    return msgBoxConfirm.call(
      this,
      message,
      withConfirmDialogDefaults(options, message)
    )
  }
  proto.msgBoxOk = function (message, options) {
    // OK だけのダイアログはキャンセルが無いので、常に OK にフォーカス
    return msgBoxOk.call(this, message, withConfirmDialogDefaults(options))
  }
  Object.defineProperty(proto, '__gymsConfirmDialogStyled', { value: true })
  return true
}

export default () => {
  installConfirmDialogStyle(Vue)
}
